var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "auth-shell auth-shell--centered" }, [
    _c("div", { staticClass: "auth-card" }, [
      _c("div", { staticClass: "auth-card__logo" }, [
        _c("img", { attrs: { src: _vm.logoPath, alt: "logo" } }),
      ]),
      _c("div", { staticClass: "auth-card__heading" }, [
        _c("h3", [_vm._v(_vm._s(_vm.$t("pages.login.description")))]),
        _c("h5", [_vm._v(_vm._s(_vm.$t("pages.reset_password.init_session")))]),
      ]),
      _c(
        "form",
        {
          staticClass: "auth-card__panel",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.recoverPassword.apply(null, arguments)
            },
          },
        },
        [
          _vm.error
            ? _c(
                "div",
                { staticClass: "alert alert-danger", attrs: { role: "alert" } },
                [_vm._v(" " + _vm._s(_vm.error) + " ")]
              )
            : _vm._e(),
          _c("name-field", {
            attrs: { form: _vm.form, name: "name", id: "name" },
          }),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("vue-button", {
                staticClass: "btn btn-primary btn-block p-3 text-uppercase",
                attrs: {
                  title: _vm.$t("pages.reset_password.reset_now"),
                  loading: _vm.isLoading,
                  type: "submit",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "auth-card__footer-link" },
        [
          _c("router-link", { attrs: { to: { name: "login" } } }, [
            _vm._v(_vm._s(_vm.$t("pages.reset_password.login_return"))),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "auth-card__copyright" }, [
        _vm._v(" " + _vm._s(_vm.copyright) + " "),
      ]),
      _c(
        "div",
        { staticClass: "auth-card__stores" },
        [
          _c("google-play-badge", { staticClass: "mr-3" }),
          _c("apple-store-badge"),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }